export const EMPTY_ARRAY = [];
export const EMPTY_OBJECT = {};

/**
 * @deprecated
 * These exports have moved. Import them from `@qmulus/ui/utils/common.ts` instead.
 */
export {
  isDefined,
  isNullish,
  nullishToNull,
  nullishToUndefined,
} from '@qmulus/ui/utils/common.ts';

/**
 * @deprecated
 * This export has moved. Import it from `@qmulus/ui/utils/object.ts` instead.
 */
export {
  isPlainObject,
} from '@qmulus/ui/utils/object.ts';
